import { OverlayTrigger, Popover } from "react-bootstrap";
import { OvertimeWorkedAndScheduledPerPeriodModel } from "../../../models/OvertimeSchedule";

const formatEmployeeTitle = (fullName: string) =>
  fullName
    .toLowerCase()
    .split(" ")
    .filter(Boolean)
    .map((part) => `${part.charAt(0).toUpperCase()}${part.slice(1)}`)
    .join(" ");

interface Props {
  employee: OvertimeWorkedAndScheduledPerPeriodModel;
}

export const EmployeeInfoCell = ({ employee }: Props) => {
  const fullNameTitle = formatEmployeeTitle(employee.fullName);

  const popover = (
    <Popover id={`employee-info-${employee.employeeId}`}>
      <Popover.Header as="div">Información del empleado</Popover.Header>
      <Popover.Body>
        <div className="d-flex flex-column gap-1 text-start text-dark small">
          <span>Nombre: {fullNameTitle}</span>
          <span>Documento: {employee.documentNumber || "--"}</span>
          <span>Ficha: {employee.cardNumber || "--"}</span>
          <span>Grupo: {employee.groupName || "--"}</span>
        </div>
      </Popover.Body>
    </Popover>
  );

  return (
    <OverlayTrigger
      trigger={["hover", "focus"]}
      placement="right"
      overlay={popover}
    >
      <div style={{ cursor: "default", minWidth: 0 }}>
        <div className="d-flex align-items-center gap-1">
          <span className="text-dark fw-semibold fs-6 employee-name-truncate text-nowrap">
            {fullNameTitle}
          </span>
        </div>

        <div className="d-flex align-items-center justify-content-between gap-3">
          <div className="text-muted " style={{ fontSize: "0.7rem" }}>
            CO: {employee.documentNumber}
          </div>

          <div
            className="text-muted small employee-group-truncate"
            title={employee.groupName}
            style={{ fontSize: "0.63rem" }}
          >
            {employee.groupName.toLowerCase()}
          </div>
        </div>
      </div>
    </OverlayTrigger>
  );
};
